export default __webpack_public_path__ + "static/media/2021-bottom.f6c3461e.svg";